<template>
  <div
    id="main-video-container"
    class="cursor-sensitive"
    data-cursor-default='{"left":1500, "top":500}'
  >
    <video
      :class="['wp-block-cover__video-background', state_class]"
      v-on:click="openPlayer"
      autoplay=""
      muted=""
      loop=""
      preload="none"
      id="main-video"
      :src="[video_src]"
    ></video>
    <div class="caption mouse-blocker" v-html="video_caption"></div>
    <a
      class="scroll-down mouse-blocker"
      v-on:click="scrollTo"
      href="#main-content"
      >{{ trans.scroll_down }}</a
    >
    <div id="cursor-mask"></div>
    <div class="inner-cursor cursor"></div>
  </div>
</template>

<script>
export default {
  name: "MainVideo",
  data() {
    return {
      state_class: "",
      trans: {
        scroll_down: window.APP_INFO.trans.scroll_down,
      },
    };
  },
  methods: {
    openPlayer(e) {
      //console.log(e)
      //console.log(this.video_src)
      e.preventDefault();
      this.$emit("open_player", this.video_src);
    },
    scrollTo(e) {
      e.preventDefault();
      const href = e.target.getAttribute("href");

      const $element = document.getElementById(
        e.target.getAttribute("href").substr(1, href.length - 1)
      );

      window.scrollBy({
        top: $element.offsetTop - document.documentElement.scrollTop,
        behavior: "smooth",
      });
    },
  },
  props: {
    video_src: {
      type: String,
      required: false,
    },
    video_caption: {
      type: String,
      required: false,
    },
  },
  created() {
    const vm = this;
    //vm.showVideo(vm.content.page)
  },
  mounted() {
    const vm = this;
  },
  updated() {
    const vm = this;
    console.log("video updated " + this.video_src);
    console.log("video updated " + this.video_caption);
    if (this.video_src != "") {
      this.state_class = "show";
    }
    //console.log('updated')

    //vm.showVideo(vm.content.page);
  },
};
</script>

<style lang="scss">
#main-video-container {
  overflow: hidden;
  position: relative;
  height: 100vh;
  width: 100vw;
  display: block;
  background-color: #000;

  video {
    cursor: pointer;
    position: absolute;
    min-width: 100%;
    min-height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 1s;
    &.show {
      opacity: 0.8;
    }
  }

  .caption {
    z-index: 1;
    position: absolute;
  }
}
</style>